import { useEffect } from "react";

const PROD_ORIGIN = "https://agenzee.it";

// Sets the essentials for a public marketing page:
// document.title, meta description, canonical link, and Open Graph tags.
// Restores previous title on unmount so SPA transitions don't stack titles.
export const useSeo = ({ title, description, path }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector.replace(/^meta\[|\]$/g, "").split("=");
        el.setAttribute(key, (val || "").replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", `${PROD_ORIGIN}${path}`);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${PROD_ORIGIN}${path}`);

    return () => { document.title = prevTitle; };
  }, [title, description, path]);
};
